import React, { useContext } from 'react';
import styles from "./Currency.module.css";
import noteContext from "../Context/NoteContext";

const currencies = [
  { code: 'PKR', symbol: 'Rs', name: 'Pakistani Rupee' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
];

export default function Currency() {
  const { setSelectedCurrency,selectedCurrency  } = useContext(noteContext);

  const handleSelect = (currency) => {
    setSelectedCurrency(currency);
    alert(`Currency changed to ${currency.code}`);
  };

  return (
    <div className={styles.Container}>
      <h2>Select Currency</h2>
      <div className={styles.Grid}>
        {currencies.map((curr) => (
          <div 
            key={curr.code} 
            className={`${styles.Card} ${selectedCurrency?.code === curr.code ? styles.ActiveCard : ''}`} 
            onClick={() => handleSelect(curr)}
          >
            <span className={styles.Symbol}>{curr.symbol}</span>
            <div className={styles.Info}>
                <p className={styles.Code}>{curr.code}</p>
                <p className={styles.Name}>{curr.name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}